import {MenuItem, Select, TextField, Typography} from '@material-ui/core';
import React, {useEffect, useState} from 'react';
import {apiGETFEES} from '../utils/graph';
import ButtonAddFees from './ButtonAddFees';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faTrash} from '@fortawesome/pro-solid-svg-icons';

type PricingProps = {
  fees: Array<{
    id: string;
    feeName: string;
    feePercentage: number;
    amount?: string;
  }>;
  pricePer: string;
  price: string;
  onFees: (
    fees: Array<{
      id: string;
      feeName: string;
      feePercentage: number;
      amount?: string;
    }>,
  ) => void;
  onPricePer: (pricePer: string) => void;
  onPrice: (price: string) => void;
};

const Pricing = (props: PricingProps) => {
  const [fees, setFees] = useState<
    Array<{id: string; feeName: string; feePercentage: number}>
  >([]);
  const [selectedFees, setSelectedFees] = useState<
    Array<{id: string; feeName: string; feePercentage: number; amount?: string}>
  >(props.fees ?? []);
  const [price, setPrice] = useState<string>(props.price ?? '');
  const [pricePer, setPricePer] = useState<string>(props.pricePer ?? '');

  useEffect(() => {
    apiGETFEES().then(setFees);
  }, []);
  useEffect(() => {
    props.onFees?.(selectedFees);
  }, [selectedFees]);
  useEffect(() => {
    props.onPricePer?.(pricePer);
  }, [pricePer]);
  useEffect(() => {
    props.onPrice?.(price);
  }, [price]);
  return (
    <div>
      <div className="title">Pricing</div>
      <>
        <div className="row">
          <div className="col-6">
            <Typography>Price</Typography>
          </div>
          <div className="col-6">
            <TextField
              className="input"
              placeholder="Enter price"
              variant="outlined"
              fullWidth
              value={price}
              onChange={(e) => setPrice(e.target.value)}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-6">
            <Typography>Price per</Typography>
          </div>
          <div className="col-6">
            <Select value={pricePer} fullWidth variant="outlined">
              {['ton', 'kg'].map((title) => (
                <MenuItem
                  key={title}
                  value={title}
                  onClick={() => setPricePer(title)}
                >
                  {title}
                </MenuItem>
              ))}
            </Select>
          </div>
        </div>
      </>
      <div className="title">Deductions / additional services</div>
      <>
        {selectedFees.map((fee) => (
          <div className="row" key={fee.id}>
            <div className="col-6">
              <Typography>{fee.feeName}</Typography>
            </div>
            <div
              className="col-6"
              style={{display: 'flex', alignItems: 'center', gap: '10px'}}
            >
              <TextField
                className="input"
                placeholder={`Enter amount`}
                variant="outlined"
                fullWidth
                value={fee.amount}
                onChange={(e) =>
                  setSelectedFees(
                    selectedFees.map((f) =>
                      f.id === fee.id ? {...f, amount: e.target.value} : f,
                    ),
                  )
                }
                //   error={!!error}
                //   helperText={error ? error.message : null}
                //   disabled={props.isLoading}
              />
              <FontAwesomeIcon
                icon={faTrash}
                className="pointer"
                onClick={() =>
                  setSelectedFees(selectedFees.filter((f) => f.id !== fee.id))
                }
              />
            </div>
          </div>
        ))}
        {selectedFees.length !== fees.length && (
          <div className="row">
            <div className="col-6"></div>
            <div className="col-6">
              <ButtonAddFees
                title="Add another deduction"
                options={
                  fees?.map((fee) => ({name: fee.feeName, ...fee})) || []
                }
                selectedOptions={selectedFees}
                onSelect={(fee) => setSelectedFees([...selectedFees, fee])}
              />
            </div>
          </div>
        )}
      </>
    </div>
  );
};

export default Pricing;
